import { render, staticRenderFns } from "./VuesticFileUpload.vue?vue&type=template&id=1173b833"
import script from "./VuesticFileUpload.vue?vue&type=script&lang=js"
export * from "./VuesticFileUpload.vue?vue&type=script&lang=js"
import style0 from "./VuesticFileUpload.vue?vue&type=style&index=0&id=1173b833&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1173b833')) {
      api.createRecord('1173b833', component.options)
    } else {
      api.reload('1173b833', component.options)
    }
    module.hot.accept("./VuesticFileUpload.vue?vue&type=template&id=1173b833", function () {
      api.rerender('1173b833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-file-upload/VuesticFileUpload.vue"
export default component.exports